import styled, { css } from 'styled-components';
import { Box } from '@bechtel/gds';
const listHeight = '295px';
export const ListContainerStyled = styled(Box).attrs({
  flexDirection: { sm: 'column' },
})`
  height: ${listHeight};
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
  ${({ theme }) => css`
    background-color: ${theme.colors.white};
    border-radius: ${theme.radii[200]};
  `};
`;

export const ListSelectionStyled = styled(Box).attrs({
  py: { sm: '450' },
  px: { sm: '500' },
  justifyContent: { sm: 'space-between' },
})`
  border-bottom: 1px solid ${({ theme }) => theme.colors.grey[300]};
  cursor: pointer;
  &:hover {
    background-color: ${({ theme }) => theme.colors.grey[100]};
  }
`;

export const RodRoomContainerStyled = styled(Box).attrs({
  justifyContent: { sm: 'center' },
  alignItems: { sm: 'center' },
})`
  height: 100vh;
  width: 100%;
  ${({ theme }) => css`
    background-color: ${theme.colors.grey[200]};
  `};
`;

export const RodRoomLogoStyled = styled(Box).attrs({
  mb: { sm: '900' },
})`
  ${({ theme }) => css`
    color: ${theme.colors.white};
    border-radius: ${theme.radii[800]};
    background-color: ${({ theme }) => theme.colors.bechtel.blue[700]};
    border-color: ${({ theme }) => theme.colors.bechtel.blue[500]};
  `};
`;
